/* ============================================================================
 * 设置菜单 —— 把 V2 已实现但从未暴露入口的两个开关接出来：
 *   F-07  [data-density="dense"] 紧凑密度
 *   F-13  [data-contrast="strict"] 严格对比（WCAG AA 硬合规场景）
 * ========================================================================== */
import { useEffect, useRef, useState } from 'react';
import { useUi } from '@/store/ui';
import { Icon } from './Icon';

export function SettingsMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const { density, setDensity, contrast, setContrast } = useUi();

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [open]);

  return (
    <div className="menuwrap" ref={ref}>
      <button className="iconbtn" onClick={() => setOpen((v) => !v)} aria-haspopup="menu" aria-expanded={open} aria-label="显示设置">
        <Icon name="sliders" />
      </button>
      {open && (
        <div className="menu" role="menu">
          <div className="menu-sec">显示密度</div>
          <button role="menuitemradio" aria-checked={density === 'default'} className={`menu-item${density === 'default' ? ' on' : ''}`} onClick={() => setDensity('default')}>
            <Icon name={density === 'default' ? 'check' : 'plus'} size={13} style={{ opacity: density === 'default' ? 1 : 0 }} />
            标准
          </button>
          <button role="menuitemradio" aria-checked={density === 'dense'} className={`menu-item${density === 'dense' ? ' on' : ''}`} onClick={() => setDensity('dense')}>
            <Icon name="check" size={13} style={{ opacity: density === 'dense' ? 1 : 0 }} />
            紧凑
            <span className="menu-hint">大屏信息密集场景</span>
          </button>

          <div className="menu-sep" />
          <div className="menu-sec">对比度</div>
          <button role="menuitemradio" aria-checked={contrast === 'default'} className={`menu-item${contrast === 'default' ? ' on' : ''}`} onClick={() => setContrast('default')}>
            <Icon name="check" size={13} style={{ opacity: contrast === 'default' ? 1 : 0 }} />
            品牌观感
          </button>
          <button role="menuitemradio" aria-checked={contrast === 'strict'} className={`menu-item${contrast === 'strict' ? ' on' : ''}`} onClick={() => setContrast('strict')}>
            <Icon name="check" size={13} style={{ opacity: contrast === 'strict' ? 1 : 0 }} />
            严格合规
            <span className="menu-hint">主按钮与辅助文本提到 WCAG AA</span>
          </button>
        </div>
      )}
    </div>
  );
}
